import React from 'react';
import 'src/styles/dfp-home-page/dfp-top-navigation.scss';
import { GlobalSearchBar } from 'src/components/global-search/GlobalSearchBar';
import { TopNavLogo } from './TopNavLogo';
import { useEmbeddedApp } from 'src/hooks/useEmbeddedApp';
import { TopNavActions } from './TopNavActions';

export const DFPTopNavigation: React.FC = () => {
  const embeddedAppState = useEmbeddedApp();

  return (
    <nav className="dfp-top-nav" aria-label="Main navigation">
      <TopNavLogo {...embeddedAppState} />
      <div className="dfp-top-nav__center">
        <GlobalSearchBar isEmbedActive={!!embeddedAppState.embeddedApp} />
      </div>
      <TopNavActions embeddedApp={embeddedAppState.embeddedApp} sendMessageToEmbed={embeddedAppState.sendMessageToEmbed} />
    </nav>
  );
};
